import Grid from '@mui/material/Grid'
import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const StyledGrid = styled(Grid)`
  margin-top: 0;
  margin-bottom: 0;

  & > .MuiGrid-item {
    padding-top: 0;
    padding-bottom: 0;
  }
`

const GutterGrid = ({ xs, md, lg, xl, ...rest }) => {
  // const isSM = useMediaQuery({ minWidth: 576, maxWidth: 767 })
  const theme = useTheme()
  const isMD = useMediaQuery(theme.breakpoints.between('md', 'lg'))
  const isLG = useMediaQuery(theme.breakpoints.between('lg', 'xl'))
  const isXL = useMediaQuery(theme.breakpoints.up('xl'))

  const defaultSpacing = xs ? 2 : 0
  const [spacing, setSpacing] = useState(defaultSpacing)

  useEffect(() => {
    if (isMD) {
      md && setSpacing(4)
    } else if (isLG) {
      lg && setSpacing(6)
    } else if (isXL) {
      xl && setSpacing(8)
    } else {
      xs && setSpacing(defaultSpacing)
    }
  }, [isMD, isLG, isXL])

  return <StyledGrid container spacing={spacing} {...rest} />
}

GutterGrid.defaultProps = {
  xs: true,
  md: true,
  lg: true,
  xl: true,
}

export default GutterGrid
